/* eslint-disable no-mixed-operators */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import EmptyState from 'Components/common/components/EmptyState';

type Props = {
  xAxis: (string | undefined)[];
  scores: (number | undefined)[] | undefined;
  teamRank: (number | undefined)[] | undefined;
  team: boolean | false;
  teamRankCount: number;
};

const BarLineChart: React.FC<Props> = function BarLineChart(props: Props) {
  const {
    xAxis, scores, teamRank, team, teamRankCount,
  } = props;

  const options = {
    credits: {
      enabled: false,
    },
    chart: {
      height: 350,
      marginTop: 40,
      zoomType: 'xy',
      panning: true,
      panKey: 'shift',
      events: {
        load(this: Highcharts.Chart) {
          const chart = this;
          const { container } = chart;
          if (container instanceof HTMLElement) {
            container.addEventListener('wheel', (e: WheelEvent) => {
              e.preventDefault();
              const delta = e?.deltaY < 0 ? 1.1 : 0.9;
              const extremes = chart.xAxis[0].getExtremes();
              const newMin = extremes.min + (extremes.max - extremes.min) * (1 - delta) / 2;
              const newMax = extremes.max - (extremes.max - extremes.min) * (1 - delta) / 2;
              chart.xAxis[0].setExtremes(newMin, newMax);
            });
          }
        },
      },
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    plotOptions: {
      series: {
        pointWidth: 16,
      },
    },
    xAxis: [
      {
        categories: xAxis
      },
    ],
    yAxis: [
      {
        // Primary yAxis (Score)
        lineWidth: 1,
        tickWidth: 1,
        labels: {
          format: '{value}',
        },
        title: {
          text:
            '<span style="font-size: 14px; font: Roboto; font-weight: 700; color: #000">Score</span>',
          align: 'high',
          offset: 0,
          rotation: 0,
          y: -10,
        },
      },
      {
        // Secondary yAxis (Rank)
        lineWidth: 1,
        tickWidth: 1,
        title: {
          text:
            '<span style="font-size: 14px; font: Roboto; font-weight: 700; color: #000; marginBottom: 5px">Rank</span>',
          align: 'high',
          offset: 0,
          rotation: 0,
          y: -10,
        },
        labels: {
          format: '{value}',
        },
        opposite: true,
      },
    ],
    tooltip: {
      shared: true,
    },
    legend: {
      useHTML: true,
      labelFormatter(): string {
        return `<span style="font-size:14px; font-weight: 400; font-family: Roboto; color: #61769E;">
          <span><br /> 
            within ${team ? `${teamRankCount} teams` : `${teamRankCount} members`}
            <span><br /> (within 10 employees)</span>
          </span>
        </span>`;
      },
    },
    series: [
      {
        name: 'Score',
        type: 'column',
        yAxis: 0,
        color: '#6A34DF',
        data: scores,
        tooltip: {
          valueSuffix: '',
        },
      },
      {
        name: 'Team Rank',
        type: 'spline',
        yAxis: 1,
        data: teamRank,
        color: '#DF3434',
        tooltip: {
          valueSuffix: '',
        },
      },
    ],
  };

  return (
    <div className="barlinechart">
      {scores?.length === 0 && teamRank?.length === 0 ? (
        <EmptyState
          msg="No analytics data found"
          detail="Try adjusting your filters to find what you are looking for"
          height="350px"
        />
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </div>
  );
};

export default BarLineChart;
